import { render, staticRenderFns } from "./SignApply.vue?vue&type=template&id=3d896d54&scoped=true&"
import script from "./SignApply.vue?vue&type=script&lang=js&"
export * from "./SignApply.vue?vue&type=script&lang=js&"
import style0 from "./SignApply.vue?vue&type=style&index=0&id=3d896d54&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d896d54",
  null
  
)

export default component.exports